module.exports = __webpack_public_path__ + "img/ORO.f644de8b.png";